export const authConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',

  endpoints: {
    oidcAuthenticate: '/oidc/authenticate/',
    oidcCallback: '/oidc/callback/',
    multiProviderLogin: '/auth/login/',
    loginGoogle: '/auth/login/google/',
    loginMicrosoft: '/auth/login/microsoft/',
    token: '/auth/token/',
    tokenRotate: '/auth/token/rotate/',
    tokenRevoke: '/auth/token/revoke/',
    tokenLogin: '/auth/token/login/',
    currentUser: '/auth/me/',
    logout: '/auth/logout/',
    authStatus: '/api/auth/status/',
    refreshAuth: '/api/auth/refresh/',
    sessionInfo: '/auth/session-info/',
  },

  tokenRefreshInterval: 15 * 60 * 1000, // 15 minutes
  tokenExpiryBuffer: 5 * 60 * 1000, // 5 minutes buffer
  sessionTimeout: 7 * 24 * 60 * 60 * 1000, // 7 days

  storage: {
    // tokenKey removed — auth token is now in HttpOnly cookie
    userKey: 'botunify_user',
    postLoginRedirectKey: 'botunify_post_login_redirect',
  },

  redirectPaths: {
    afterLogin: '/',
    afterLogout: '/login',
    authCallback: '/auth/callback',
  },

  enableAutoRefresh: true,
  enablePersistence: true,
  enableSecureStorage: true,

  headers: {
    authorization: 'Token',
    contentType: 'application/json',
  },

  retryConfig: {
    maxRetries: 3,
    retryDelay: 1000,
    retryableStatuses: [408, 429, 500, 502, 503, 504],
  },
};

export type AuthConfig = typeof authConfig;
